<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <!-- <div class="h-screen flex w-full bg-img vx-row no-gutter justify-center items-center"> -->
    <div class="flex w-full bg-img vx-row no-gutter justify-center items-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-2/5 m-4">

      <vx-card>
        <div class="vx-card__title mb-6">
          <h4 class="text-center">{{activeUserInfo.displayName}} 님의</h4>
          <h2 class="text-center">클래스을 생성 합니다.</h2>  &nbsp;
          <p class="text-center">사용자 클래스을 만들어 프로젝트를 관리해보세요.</p> <br>
        </div>

        <div class="centerx default-input">
        <vs-input class="mx-auto mb-2" placeholder="클래스명을 입력하세요" icon-after="true" icon="mode_edit" v-model="spaceName"/>

        <img src="@/assets/images/pages/maintenance.png" alt="CreateSpace" class="mx-auto mb-2" width="250px" height="200px">


          <!-- <countdown :time="new Date('03/09/2021 00:00:00').getTime() - new Date().getTime()">

            <template slot-scope="props">

              <div class="single-counter">
                <span class="timer">{{ props.days }}</span>
                <span>Days</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.hours }}</span>
                <span>Hours</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.minutes }}</span>
                <span>Minutes</span>
              </div>

              <div class="single-counter">
                <span class="timer">{{ props.seconds }}</span>
                <span>Seconds</span>
              </div>

            </template>
          </countdown> -->
          <!-- <vs-input icon-after="true" label-placeholder="icon-after" icon="mode_edit" placeholder="클래스명" v-model="spaceName"/> -->
        </div>
        <!-- <vs-divider position="center">클래스명</vs-divider> -->
        <div class="subscription" line-height="5px">
          <!-- <span>사용자 클래스을 만들어 프로젝트를 관리해보세요.</span> <br> -->

          <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-4" /> -->
          <br>
          <vs-button class="w-full" :disabled="!validateForm" @click="done()" >생성하기</vs-button>
          <br><br>
          <span>문의사항: mesen@filledyou.com</span>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VueCountdown from '@chenfengyuan/vue-countdown'

export default {
  data() {
    return {
      spaceName: 'AClass',
      spaceDetail: ''
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    validateForm() {
      return !this.errors.any() && this.spaceName != '';
  }
},
  components: {
    'countdown': VueCountdown
  },
  methods: {
    done() {
      const payload = {
        title: this.spaceName,
        detail: this.spaceDetail
      }      
      this.$store.dispatch('space/createWorkspace', payload)
    }
  }
}

</script>

<style lang="stylus">
  .default-input
  .vs-input
    margin-top 10px
    margin-bottom 10px
</style>
